





































































































































































































































































































































import { ActivityIcon } from '@/components';
import {
  ActivityGroup,
  ActivitySubtype,
  ActivityType,
  GeekItem, TranslatedActivitySubtype, TranslatedActivityType,
} from '@/models';
import { GeekRewardingRequest, GeekRewardingRequestPayload } from '@/models/reward-geek';
import { collapseMixin, asyncSelectMixin } from '@/shared';
import { Actions, Getters, typedStore } from '@/store';
import { ToastsService, resetModel } from '@/utils';
import Vue from 'vue';
import Multiselect from 'vue-multiselect';
import mixins from 'vue-typed-mixins';
import { AllGeeksMultipleSelect } from '@/components';

export default mixins(
  asyncSelectMixin(Actions.geek.resetGeeks, Actions.geek.fetchGeeks),
  collapseMixin,
).extend({
  name: 'RewardGeek',
  components: {
    ActivityIcon,
    Multiselect,
    AllGeeksMultipleSelect,
  },
  data() {
    return {
      rewardGeekForm: {
        geekIds: [] as string[],
        activity: (null as unknown) as ActivityType,
        subactivity: (null as unknown) as ActivitySubtype,
        reason: '',
        signature: (null as unknown) as string,
      },
      requestStatusIconMap: {
        rejected: 'log-icon-close',
        pending: 'log-icon-pending',
        accepted: 'log-icon-check',
      },
      loader: {
        isRewardRequestSending: false,
        isRewardRequestListPending: true,
      },
    };
  },
  async created(): Promise<void> {
    await this.$store.dispatch(Actions.activities.fetchAll);
    try {
      await this.$store.dispatch(Actions.activities.fetchRequests);
    } finally {
      this.loader.isRewardRequestListPending = false;
    }
  },
  computed: {
    filteredGeeks(): GeekItem[] {
      return typedStore(this).getters[Getters.geek.filtered];
    },
    activities(): ActivityGroup[] {
      return typedStore(this).state.activities.all.map(activityGroup => {
        return {
          skill: activityGroup.skill,
          activityTypes: activityGroup.activityTypes.map(activityType => {
            return {
              ...activityType,
              translatedName: this.$t(`activity.types.${activityType.name}.name`),
            } as TranslatedActivityType;
          }),
        } as ActivityGroup;
      });
    },
    collapsibleItems(): GeekRewardingRequest[] {
      return typedStore(this).state.activities.requests;
    },
    requestsCount(): number {
      return typedStore(this).state.activities.pagination.totalCount;
    },
    areMoreItemsAvailable(): boolean {
      return this.collapsibleItems.length < this.requestsCount && this.collapsibleItems.length > 0;
    },
    hasSelectedActivitySubtypes(): boolean {
      return this.rewardGeekForm.activity && (this.rewardGeekForm.activity.subtypes as ActivitySubtype[]).length > 0;
    },
    canHaveSignature(): boolean {
      return this.rewardGeekForm.activity && this.rewardGeekForm.activity.canHaveSignature === true;
    },
    subactivityValidationRules(): string | boolean {
      return this.hasSelectedActivitySubtypes
        ? 'required'
        : false;
    },
    activitySubtypes(): ActivitySubtype[] {
      return (this.rewardGeekForm.activity && this.rewardGeekForm.activity.subtypes || []).map(x => {
        return {
          ...x,
          translatedName: this.$t(`activity.subtypes.${x.name}.name`),
        } as TranslatedActivitySubtype;
      });
    },
  },
  methods: {
    async checkForm() {
      const valid = await this.$validator.validateAll();

      if (!valid) {
        return;
      }

      const requestGeekRewardData: GeekRewardingRequestPayload = {
        geekId: '',
        activityTypeId: this.rewardGeekForm.activity.id,
        activitySubtypeId: this.rewardGeekForm.subactivity
          ? this.rewardGeekForm.subactivity.id
          : undefined,
        reason: this.rewardGeekForm.reason,
        signature: this.rewardGeekForm.signature,
      };

      this.loader.isRewardRequestSending = true;

      try {
        for (const id of this.rewardGeekForm.geekIds) {
          requestGeekRewardData.geekId = id;
          await this.$store.dispatch(
            Actions.activities.postActivityRequest,
            requestGeekRewardData,
          );
        }
        ToastsService.success(this.$t('reward-geek.activity-request-success-message') as string);
        this.loader.isRewardRequestSending = false;
        this.loader.isRewardRequestListPending = true;
        this.rewardGeekForm = {...resetModel(this.rewardGeekForm)};
        this.$validator.reset();
        (this as any).$refs.geekSelect.clearSelected();

        try {
          await this.$store.dispatch(Actions.activities.fetchRequests);
        } finally {
          this.loader.isRewardRequestListPending = false;
        }
      } finally {
        this.loader.isRewardRequestSending = false;
      }
    },
    clearSubactivity() {
      this.rewardGeekForm.subactivity = (null as unknown) as ActivitySubtype;
    },
    async loadMoreRequests() {
      this.loader.isRewardRequestListPending = true;
      try {
        await this.$store.dispatch(Actions.activities.fetchMoreRequests);
      } finally {
        this.loader.isRewardRequestListPending = false;
      }
    },
    getFormattedDateTime(dateTime: string): string {
      return (this as any).$options.filters.formattedDate(dateTime);
    },
    async updateSelectedGeeks(geekItems: GeekItem[]) {
      this.rewardGeekForm.geekIds = [] as string[];
      if (geekItems)  {
        const geekIds = geekItems.map(g => g.id);
        this.rewardGeekForm.geekIds = geekIds;
      }
      await this.$validator.reset();
    },
  },
});
